import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 创建 Vuex store 实例
const store = new Vuex.Store({
  state: {
    menuData: [],         // 初始值为空数组
    userInfo: {},         // 初始值为空对象
    token: localStorage.getItem('token') || '',  // 从 localStorage 读取 token
    isLogin: false        // 初始为 false
  },
  mutations: {
    // 设置登录状态
    setLoginStatus(state, status) {
      state.isLogin = status;
    },
    // 一键登录：设置 token、用户信息、登录状态，并存 localStorage
    setLogin(state, { token, userInfo }) {
      state.token = token;
      state.userInfo = userInfo;
      state.isLogin = true;
      localStorage.setItem('token', token);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    // 退出登录
    logout(state) {
      state.token = '';
      state.userInfo = {};
      state.isLogin = false;
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
    },
    // 设置菜单数据
    setMenuData(state, menuData) {
      state.menuData = menuData;
      localStorage.setItem('menuData', JSON.stringify(menuData));
    },
    // 单独设置用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    // 清除用户信息
    clearUserInfo(state) {
      state.userInfo = {};
      localStorage.removeItem('userInfo');
    },
    // 单独设置 token
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    // 清除 token
    clearToken(state) {
      state.token = '';
      localStorage.removeItem('token');
    }
  }
})

// 🔧 ==========================
// 🔧 自动恢复登录状态（token + userInfo + isLogin）
// 🔧 ==========================
const token = localStorage.getItem('token');
const userInfoStr = localStorage.getItem('userInfo');

if (token && userInfoStr) {
  try {
    const userInfo = JSON.parse(userInfoStr);
    store.commit('setLogin', {
      token: token,
      userInfo: userInfo
    });
  } catch (e) {
    console.error('解析 userInfo 失败，清除无效数据', e);
    store.commit('logout');
  }
} else {
  store.commit('setLoginStatus', false);
}

// 🔧 ==========================
// 🔧 自动恢复 menuData（菜单数据）
// 🔧 ==========================
const menuDataStr = localStorage.getItem('menuData');
if (menuDataStr) {
  try {
    const menuData = JSON.parse(menuDataStr);
    store.commit('setMenuData', menuData); // 恢复 menuData 到 Vuex
  } catch (e) {
    console.error('解析 menuData 失败，清除无效数据', e);
    store.commit('setMenuData', []); // 出错时设为空数组
  }
} else {
  // 如果没有保存的 menuData，确保它是空数组（已经默认是了，可省略）
  store.commit('setMenuData', []);
}

// 🔧 最后导出 store
export default store;